import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboPercursoComponent} from './combo-percurso.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {ComboPesquisavelModule} from '../combo-pesquisavel/combo-pesquisavel.module';


@NgModule({
    declarations: [ComboPercursoComponent],
    imports: [
        CommonModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule
    ],
    exports: [ComboPercursoComponent]
})
export class ComboPercursoModule {
}
